// extracted by mini-css-extract-plugin
export default {"phone":"applications-components-HeaderApp-components-PhoneRussiaLink-styles-module__phone"};
    if(module.hot) {
      // 1707476361731
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  